export default __webpack_public_path__ + "6f9b9940096ca4722a71a41dbb0f3aaf.webp";